// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2l-0";
export var spinnerContainer = "_2l-1";